// @codekit-prepend "js.cookie.js";
// @codekit-prepend quiet "input-file.min.js";
// @codekit-prepend quiet "modal.min.js";
// @codekit-prepend quiet "funcs.js";
// @codekit-prepend "recliner.js";
// @codekit-prepend "contact.js";
// @codekit-prepend "search.js";
// @codekit-prepend "login.js";
// @codekit-prepend "register.js";

window.onload = function () {
  $wrapper.addEventListener("scroll", lazyLoad);
  lazyLoad();

  var cookieConsent = document.querySelector("#cookieConsent");
  if (cookieConsent) {
    setTimeout(function () {
      cookieConsent.classList.add("appear");
    }, 1000);
    var acceptBtn = cookieConsent.querySelector(".acceptCookieConsent");
    acceptBtn.addEventListener(
      "click",
      function (e) {
        e.preventDefault();
        cookieConsent.classList.remove("appear");
        Cookies.set("cookieConsent", true, { expires: 30 });
      },
      false
    );
  }

  if (document.querySelector(".sidebar")) {
    var divs = document.querySelectorAll(".anchorItem"),
      i;

    for (i = 0; i < divs.length; ++i) {
      divs[i].dataset.position = Math.round(divs[i].getBoundingClientRect().top) - 90;
    }
    var Sticky = (function () {
      "use strict";

      var CSS_CLASS_ACTIVE = "is-fixed";

      var Sticky = {
        element: null,
        position: 0,
        maxHeight: 0,
        addEvents: function () {
          document.querySelector("[sh-component=main-wrapper]").addEventListener("scroll", this.onScroll.bind(this));
        },
        init: function (element) {
          this.element = element;
          this.addEvents();
          this.position = document.querySelector(".main-content-section-wrapper").offsetHeight + document.querySelector(".main-nav").offsetHeight;
          this.onScroll();
          element.style.width = element.offsetWidth + "px";
          this.maxHeight = document.querySelector("[sh-component=main-wrapper]").offsetHeight - 120;
          element.style.maxHeight = this.maxHeight + "px";
        },
        aboveScroll: function () {
          return this.position < document.querySelector("[sh-component=main-wrapper]").scrollTop;
          return false;
        },
        onScroll: function (event) {
          if (
            document.querySelector("[sh-component=main-wrapper]").scrollTop >
            document.querySelector(".main-content-section-content").offsetHeight - 250
          ) {
            this.setStaticBottom();
          } else if (this.aboveScroll()) {
            this.setFixed();
          } else {
            this.setStatic();
          }
        },
        setFixed: function () {
          this.element.classList.add(CSS_CLASS_ACTIVE);
          // not needed if added with CSS Class
          this.element.style.position = "fixed";
          this.element.style.top = "95px";
        },
        setStatic: function () {
          this.element.classList.remove(CSS_CLASS_ACTIVE);
          // not needed if added with CSS Class
          this.element.style.position = "static";
          this.element.style.top = "auto";
        },
        setStaticBottom: function () {
          this.element.classList.remove(CSS_CLASS_ACTIVE);
          // not needed if added with CSS Class
          this.element.style.position = "relative";
          console.log();
          this.element.style.top = document.querySelector(".main-content-section-content").offsetHeight - this.maxHeight + "px";
        },
      };

      return Sticky;
    })();

    //  Init Sticky
    var sticky = document.querySelector(".sidebar");
    if (sticky) Sticky.init(sticky);
  }
};

/**********************************************************************************
 *
 * INIT
 *
 **********************************************************************************/
var $i = 0;
var $body = document.querySelector("body");
var $wrapper = document.querySelector("[sh-component=main-wrapper]");
window.requestAnimationFrame =
  window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
if (typeof $baseUrl === "undefined") {
  var $baseUrl = window.location.protocol + "//" + window.location.hostname;
}

/**********************************************************************************
 *
 * TOUCH
 *
 **********************************************************************************/
var supportsTouch = "ontouchstart" in window || navigator.msMaxTouchPoints === true;
$body.setAttribute("data-touch", supportsTouch);

/**********************************************************************************
 *
 * MENU
 *
 **********************************************************************************/
var $menuToggleMobileTrigger = document.querySelector("[sh-component=toggle-mobile]");
var $menuNav = document.querySelector("[sh-component=main-nav]");

var $menuToggleMobileFunction = function (e) {
  e.stopPropagation();
  $body.classList.toggle("menu-mobile-open");
  $menuToggleMobileTrigger.classList.toggle("open");
};
if ($menuToggleMobileTrigger != null) {
  $menuToggleMobileTrigger.setAttribute("onclick", "event.stopPropagation(); return false;");
  $menuToggleMobileTrigger.addEventListener("click", $menuToggleMobileFunction);
}

var $menuSetNavigationScroll = function () {
  if ($menuToggleMobileTrigger == null || $menuToggleMobileTrigger.offsetHeight > 0) {
    return false;
  }
  if ($wrapper.scrollTop > $menuNav.offsetHeight) {
    $menuNav.classList.add("scrolled");
  } else {
    $menuNav.classList.remove("scrolled");
  }
};

/**********************************************************************************
 *
 * FOOTER
 *
 **********************************************************************************/
var $mainFooterMenuItemTriggers = document.querySelectorAll("[sh-component=mainFooterMenuItemTrigger]");
var $mainFooterMenuItemTriggersFunction = function (e) {
  if (document.querySelector("body[data-touch=false]")) {
    return false;
  }
  if (e.target !== null) {
    for ($i = 0; $i < $mainFooterMenuItemTriggers.length; $i++) {
      var __item = $mainFooterMenuItemTriggers[$i];
      if (__item !== e.target) {
        __item.parentNode.classList.remove("open");
      }
    }
    var __parent = e.target.parentNode;
    __parent.classList.toggle("open");
  }
  return false;
};

if ($mainFooterMenuItemTriggers != null) {
  for ($i = 0; $i < $mainFooterMenuItemTriggers.length; $i++) {
    var __item = $mainFooterMenuItemTriggers[$i];
    __item.setAttribute("onclick", "event.stopPropagation(); return false;");
    __item.addEventListener("click", $mainFooterMenuItemTriggersFunction);
  }
}

/**********************************************************************************
 *
 * CONTEXT
 *
 **********************************************************************************/
var $onEnterFrame = function () {
  // menu
  $menuSetNavigationScroll();
  // register
  registerTestPosStep();
  // loop
  requestAnimationFrame($onEnterFrame);
};
$onEnterFrame();

var triggerVideo = function (elem) {
  resetPopin(".videoPlayer");

  var options = {
    id: elem.dataset.video,
    width: 640,
    loop: false,
  };

  player = new Vimeo.Player("iframeContainer", options);
  setTimeout(function () {
    player.play();
  });

  handleConfirmationAnim("show");
};

var handleConfirmationAnim = function (status) {
  var popin = document.querySelector("#registerPopin");
  const targetElement = document.querySelector("#registerPopin");

  if (status == "show") {
    bodyScrollLock.disableBodyScroll(targetElement);
    popin.style.display = "flex";
    // popin.classList.toggle('active');
    setTimeout(function () {
      popin.classList.add("reveal");
    }, 200);
    setTimeout(function () {
      popin.querySelector(".container").classList.add("isActive");
    }, 500);
  } else {
    if (player != null) {
      player.pause();
    }
    bodyScrollLock.enableBodyScroll(targetElement);
    //document.querySelector("#intercom-container").style.display = "block";
    popin.querySelector(".container").classList.remove("isActive");
    setTimeout(function () {
      popin.classList.remove("reveal");
      setTimeout(function () {
        // popin.classList.toggle('active');
        popin.style.display = "none";
      }, 200);
    }, 500);
  }
};

var getAppointmentRecap = function (element) {
  var popin = document.querySelector("#registerPopin");

  document.querySelector("#registerPopin .container").style.width = "100%";
  if (!document.querySelector(".psy-details")) {
    //document.querySelector("#intercom-container").style.display = "none";
    // popin.querySelector("#iframeContainerBooking").innerHTML =
    //     '<iframe id="bookingIframe" src="' +
    //     baseUrl +
    //     "/app/booking/" +
    //     element.dataset.serial +
    //     '/?register=true"></iframe>';
    var iframe = document.createElement("iframe");
    iframe.id = "bookingIframe";
    resetPopin(".bookingContent");
    handleConfirmationAnim("show");

    iframe.onload = function () {
      document.querySelector("#registerPopin .page-register-loading-content").style.display = "none";
    }; // before setting 'src'
    iframe.src = baseUrl + "/app/booking/" + element.dataset.serial + "/?register=true";
    popin.querySelector("#iframeContainerBooking").innerHTML = "";
    popin.querySelector("#iframeContainerBooking").appendChild(iframe);
  } else {
    var payload = {
      serial: element.dataset.serial,
    };




    var data = new FormData();
    data.append("data", JSON.stringify(payload));
    fetch($baseUrl + "/ajax/getAppointmentRecap", {
      method: "POST",
      body: data,
      credentials: "include",
    })
      .then(function (res) {
        return res.json();
      })


      .then(function (res) {
          console.log(res);
        var link = res.isLogged ? "/app/booking/" : "/register/?serial=";
        popin.querySelector(".dateLabel").innerHTML = res.date;
        popin.querySelector(".durationLabel").innerHTML = res.duration;
        popin.querySelector(".priceLabel").innerHTML = res.price;
        popin.querySelector(".selectAppointment").href = baseUrl + link + element.dataset.serial;
        popin.querySelector(".infos").style.display = res.isLogged ? "none": "block";
        if (res.type == "covid-19") {
          popin.querySelector(".notice-text").style.display = "block";
        } else {
          popin.querySelector(".notice-text").style.display = "none";
        }
        resetPopin(".confirmationContent");
        handleConfirmationAnim("show");
      })
      .catch();
  }
};

var resetPopin = function (selector) {
  var popin = document.querySelector("#registerPopin");
  var triggers = document.querySelectorAll("#registerPopin .container > div"),
    i;

  for (i = 0; i < triggers.length; ++i) {
    triggers[i].style.display = "none";
  }

  popin.querySelector(selector).style.display = "block";
};

var handleClickGlobal = function (event) {
  event = event || window.event;
  var element = event.target;

  while (element) {
    if (element.nodeName === "A" && /trigger-intercom/.test(element.className)) {
      event.preventDefault();
      break;
    }
    if (element.nodeName === "BUTTON" && /closePushTabArticle/.test(element.className)) {
      event.preventDefault();
      var parentTab = document.querySelector(".pushTabArticle");
      if(parentTab != null) 
      {
        document.cookie = "push-tab-article=1; expires=0; path=/";
        parentTab.remove();
      }
      break;
    }
    if (element.nodeName === "A" && /showMore/.test(element.className)) {
      event.preventDefault();
      var selector = document.querySelector(".bloc_category_seo");
      selector.classList.toggle("displayed_full");

      selector.querySelector(".label").innerHTML = selector.classList.contains("displayed_full") ? "Fermer" : "En savoir plus";
      break;
    }
    element = element.parentNode;
  }
};
document.addEventListener("click", handleClickGlobal, false);

var handleClick = function (event) {
  event = event || window.event;
  var element = event.target;

  while (element) {
    if (element.nodeName === "A" && /arrowsCalendar/.test(element.className)) {
      event.preventDefault();
      fetchCalendar(element, true);
    }
    if (element.nodeName === "A" && /nextSlots/.test(element.className)) {
      event.preventDefault();
      fetchCalendar(element, true);
    }
    if (element.nodeName === "A" && /showMore/.test(element.className)) {
      event.preventDefault();
      fetchCalendar(element, false);
    }
    if (element.nodeName === "A" && /appointmentSelection/.test(element.className)) {
      event.preventDefault();

      getAppointmentRecap(element);
    }
    if (element.nodeName === "DIV" && /closeConfirmation/.test(element.className)) {
      event.preventDefault();
      handleConfirmationAnim("hide");
    }
    if (element.nodeName === "A" && /triggerVideo/.test(element.className)) {
      event.preventDefault();
      triggerVideo(element);
    }
    element = element.parentNode;
  }
};

if (document.querySelector(".psy-details")) {
  var divs = document.querySelectorAll(".anchorItem"),
    i;

  for (i = 0; i < divs.length; ++i) {
    divs[i].dataset.position = Math.round(divs[i].getBoundingClientRect().top) - 90;
  }
}

if (document.querySelector(".calendar")) {
  loadCalendars();
  document.addEventListener("click", handleClick, false);
}
